import { generateUuid } from '@MyLib/System/id.js';

export const defaultFilters = {
	name: "",
	types: [],
	typesAnd: false,
	supertype: [],
	rarity: [],
	colors: [],
	colorsAnd: false,
	colorsExclude: [],
	colorless: false,
	language: "Japanese",
	searchLanguage: "Japanese",
	format: "None",
	sets: [],
	frameEffect: [],
	frameEffectExclude: [],
	keywords: [],
	artifactTypes: [],
	enchantmentTypes: [],
	landTypes: [],
	spellTypes: [],
	creatureTypes: [],
	battleTypes: [],
	availability: [],
};

export const createDeckField = () => ({
	id: generateUuid(),
	date: 0,
	deckList: []
});

export const createColumn = () => ({
	id: generateUuid(),
	name: '',
	cards: []
});

export const createCard = () => ({
	id: generateUuid(),
	uuid: 0,
	num: 0,
	language: ""
});

export const createDeck = () => ({
	id: generateUuid(),
	name: "",
	columns: [createColumn()]
});

export const createDeckInfo = (deck) => ({
	id: deck.id,
	name: deck.name
});
